exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ubicacion[data-v-27337966] {\n  background: #F7F7F7;\n  border: 1px solid #F7F7F7;\n  border-radius: 4px;\n  display: block;\n  padding-top: 14px;\n  margin-bottom: 7px;\n}\n.subtitle[data-v-27337966] {\n  color: #757575;\n}", ""]);

// exports
